import { StorageUtil } from '../../../../../shared/utils/storage';
import { EmailAccountType } from '../../../types/create-email-infrastructure';

const ADD_EMAIL_ACCOUNTS_DATA = 'addEmailAccounts_data';
const ADD_EMAIL_ACCOUNTS_DOMAIN_ID = 'addEmailAccounts_domainId';
const ADD_EMAIL_ACCOUNTS_LAST_UPDATED_AT = 'addEmailAccounts_lastUpdatedAt';

export const removeAddEmailAccountsDataFromLS = () => {
  StorageUtil.removeItem(ADD_EMAIL_ACCOUNTS_DATA);
  StorageUtil.removeItem(ADD_EMAIL_ACCOUNTS_DOMAIN_ID);
  StorageUtil.removeItem(ADD_EMAIL_ACCOUNTS_LAST_UPDATED_AT);
};

export const getAddEmailAccountsDataFromLS = (id: string) => {
  const domainId = StorageUtil.getItem(ADD_EMAIL_ACCOUNTS_DOMAIN_ID);

  if (id !== domainId) {
    removeAddEmailAccountsDataFromLS();
    return [];
  }

  const now = Date.now();
  const lastUpdatedAt = StorageUtil.getItem(ADD_EMAIL_ACCOUNTS_LAST_UPDATED_AT);
  const lastUpdatedTime = new Date(lastUpdatedAt).getTime();

  // Data updated within last 10 min
  if (now - lastUpdatedTime < 10 * 60 * 1000) {
    return JSON.parse(StorageUtil.getItem(ADD_EMAIL_ACCOUNTS_DATA)) || [];
  }

  removeAddEmailAccountsDataFromLS();
  return [];
};

export const setAddEmailAccountsDataInLS = (
  domainId: string,
  newEmailAccountsToAdd: EmailAccountType[],
) => {
  StorageUtil.setItem(ADD_EMAIL_ACCOUNTS_DOMAIN_ID, domainId);
  StorageUtil.setItem(
    ADD_EMAIL_ACCOUNTS_LAST_UPDATED_AT,
    new Date().toISOString(),
  );
  StorageUtil.setItem(
    ADD_EMAIL_ACCOUNTS_DATA,
    JSON.stringify(newEmailAccountsToAdd),
  );
};
